import Mutations from '../../odata/mutations';

export default { ...new Mutations('jobListing'), ...new Mutations('jobListings') };
